import React from 'react';
import { Link } from 'react-router-dom';
interface OutcomeShellProps {
  heading: string;
  subtext: string;
  children?: React.ReactNode;
  footnote?: string;
}

/** Deep Navy canvas, single dominant element, generous whitespace. */
const OutcomeShell = ({
  heading,
  subtext,
  children,
  footnote
}: OutcomeShellProps) => <main className="min-h-[100dvh] bg-tns-navy font-body flex items-center" data-id="element-896" data-mp="7kok0cubv54x">
    <div className="mx-auto w-full max-w-xl px-6 sm:px-8 py-16 text-center" data-id="element-897" data-mp="3otto4k41lko4">
      <p className="font-display text-sm sm:text-base tracking-[0.2em] uppercase text-tns-gold mb-12 sm:mb-16" data-id="element-898" data-mp="3tsxy3cysjmfi">
        The Networking Salon
      </p>

      <h1 className="font-display font-medium text-tns-ivory leading-[1.1] mb-5" style={{
      fontSize: 'clamp(2.25rem, 8vw, 3.75rem)'
    }} data-id="element-899" data-mp="3fuzmgfbuu43p">
        {heading}
      </h1>
      <p className="font-body text-tns-ivory/70 leading-relaxed mb-10 sm:mb-12 max-w-md mx-auto" style={{
      fontSize: 'clamp(1rem, 1.8vw, 1.15rem)'
    }} data-id="element-900" data-mp="1e3d2gxqdr9gq">
        {subtext}
      </p>

      {children}

      {footnote && <p className="mt-8 font-body text-sm text-tns-ivory/50 leading-relaxed max-w-sm mx-auto italic" data-id="element-901" data-mp="1j9p7xm1cr8u7">
          {footnote}
        </p>}
    </div>
  </main>;
const goldCta = 'inline-flex items-center justify-center w-full sm:w-auto min-h-[52px] px-9 py-3.5 rounded-lg bg-tns-gold text-tns-navy font-body font-semibold tracking-wide shadow-lg shadow-tns-gold/20 transition-all duration-200 hover:bg-tns-gold-light hover:-translate-y-0.5 active:translate-y-0 active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-tns-gold focus-visible:ring-offset-2 focus-visible:ring-offset-tns-navy';

/* ---------------------------------------------------------------- */

interface WelcomeProps {
  cityName: string;
  whatsappLink: string;
}
export const OutcomeWelcome = ({
  cityName,
  whatsappLink
}: WelcomeProps) => <OutcomeShell heading="You’re in." subtext="Welcome to the ecosystem. Your city community is waiting." footnote="Come with something to offer and something to ask for. That’s the whole deal here." data-id="element-902" data-mp="2gqe7f92txz0f">
    {whatsappLink ? <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className={goldCta} data-id="element-903" data-mp="2svtjyxillnch">
        Join the {cityName} WhatsApp Community
      </a> : <div className="rounded-xl border border-tns-gold/30 bg-tns-navy-light px-6 py-5" data-id="element-904" data-mp="32ptvpi8dxqu6">
        <p className="font-body text-tns-ivory/80 leading-relaxed" data-id="element-905" data-mp="255z8aja0m4tt">
          We don’t have a community group in {cityName || 'your city'} yet.
          We’ll reach out personally to connect you.
        </p>
      </div>}
  </OutcomeShell>;
export const OutcomeUnderReview = () => <OutcomeShell heading="We’re taking a closer look." subtext="Your application is under review by our team. This usually takes 48 hours. We’ll reach out by email with next steps." data-id="element-906" data-mp="2jun14hsh80g2" />;
export const OutcomeDeclined = () => <OutcomeShell heading="Not right now." subtext="This particular room isn’t the right fit at this stage. That’s not a closed door. Start with our Virtual Coffee Chats. They’re free, open to everyone, and a great way to experience what we’re building before applying again." data-id="element-907" data-mp="1raesvxthw4r5">
    <Link to="/events" className={goldCta} data-id="element-908" data-mp="19x5c1w28ioq7">
      See Upcoming Coffee Chats
    </Link>
  </OutcomeShell>;